/* eslint-disable camelcase */
import Cookies from "js-cookie";

const key_token = "token";
const key_cid = "cid";
const key_gray = "gray";

/**
 * 获取缓存值
 * @param {*} key
 * @param {*} flag session中未获取到值时，是否从local中获取
 */
const getSessionStorage = (key, flag) => {
    var val = ""
    if (_.get(window.dockerConfig, "dockerName")==='mp') { 
        val=wx.getStorageSync(key)
    } else
    {
        val = sessionStorage.getItem(key);
        val = !val && flag ? localStorage.getItem(key) : val;
    }

    return !val ? "" : val;
};

const setSessionStorage = (key,val, flag) => {
    sessionStorage.setItem(key, val);
    if (flag) {
        localStorage.setItem(key,val);
    }
};

const removeSessionStorage = (key, flag) => {
    sessionStorage.removeItem(key);

    if (flag) {
        localStorage.removeItem(key);
    }
};

const getStorage = (key, flag) => {
    var val = ""
    if (process.env.isMiniprogram) { 
        val=wx.getStorageSync(key)
    } else
    {
        val = sessionStorage.getItem(key);
        val = !val && flag ? localStorage.getItem(key) : val;
    }

    return !val ? "" : val;
};

/**
 * 存取缓存
 * @param {string} key 键
 * @param {object} val 值
 * @returns 
 */
const setStorage = (key, val) => {
    if (!key) {
        return; 
    }

    // 小程序
    if (process.env.isMiniprogram) { 
        val=wx.setStorageSync(key,val)
    } else // H5
    {
        sessionStorage.setItem(key, val);
    }
};


const removeStorage = (key, flag) => {

    if (!key) {
        return; 
    }

    // 小程序
    if (process.env.isMiniprogram) { 
        wx.removeStorageSync(key)
    } else // H5
    {
        sessionStorage.removeItem(key);

        if (flag) {
            localStorage.removeItem(key);
        }
    }


};

export function getCID() {
    return getSessionStorage(key_cid, true);
}

export function getToken() {
    return getSessionStorage(key_token, true);
}

export function getGray() {
    const isGray = getSessionStorage(key_gray, true) || Cookies.get(key_gray);
    return isGray === "1";
}

export function openGray() {
    setSessionStorage(key_gray,"1",true);
}

export function closeGray() {
    setSessionStorage(key_gray,"0",true);
}

export default {
    getCID,
    getToken,
    getGray,
    getStorage,
    setStorage,
    removeStorage,
    openGray,
    closeGray
};
